import * as React from 'react';
import { NavigationContainer } from '../../Navigation';
import { IInsidePageContentProps, InsidePageContent } from '../InsidePageContent';

export class ViewMobile extends React.Component<IInsidePageContentProps, {}> {
  public render() {
    return (
      <React.Fragment>
        <NavigationContainer collapsible />
        <InsidePageContent content={this.props.content} />
      </React.Fragment>
    );
  }
}
